export const CurrentAccountTypes = {
  SHOW_CURRENT_ACCOUNT: "SHOW_CURRENT_ACCOUNT",
  ADD_CURRENT_ACCOUNT: "ADD_CURRENT_ACCOUNT",
  UPDATE_CURRENT_ACCOUNT: "UPDATE_CURRENT_ACCOUNT",
  DELETE_CURRENT_ACCOUNT: "DELETE_CURRENT_ACCOUNT",
};
